import * as React from 'react'

function SvgIconMathEquality(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="math-equality" aria-labelledby="t-math-equality d-math-equality">
        <title id="t-math-equality">{'Equality'}</title>
        <desc id="d-math-equality">{'Math symbol for equality'}</desc>
        <path d="M31 22H1a1 1 0 110-2h30a1 1 0 110 2zM31 12H1a1 1 0 110-2h30a1 1 0 110 2z" />
      </g>
    </svg>
  )
}

export default SvgIconMathEquality
